export default function(callback) {
  document.addEventListener("DOMContentLoaded", callback);
}



// WEBPACK FOOTER //
// ./assets/js/ready.js